import Css from './Customer.module.css';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { Col, Row } from 'react-bootstrap';
import { useEffect } from 'react';

ChartJS.register(ArcElement, Tooltip, Legend);

export default function SuscriptionsCannellationRate({ total = 0, active = 0, nonactive = 0 }) {
    const usedPercent = Math.floor(nonactive * 100 / total);

    const data = {
        labels: ['Cancel', 'Active'],
        datasets: [
            {
                label: 'จำนวนลูกค้า',
                data: [nonactive, active],
                backgroundColor: [
                    '#A19FFB',
                    '#EDECFE',

                ],
                borderColor: [
                    '#A19FFB',
                    '#EDECFE',

                ],
                borderWidth: 1,
                cutout: '70%',
            },
        ],
    };
    const options = {
        rotation: -90,
        circumference: 180,
        plugins: {
            legend: {
                display: false
            }
        }
    }

    const textCenter = {
        id: 'textCenter',
        beforeDatasetsDraw(chart, args, pluginOptions) {
            const { ctx, data, chartArea: { left, right, top, bottom, width, height } } = chart;

            ctx.save();
            ctx.font = '18px Prompt';
            ctx.fillStyle = 'black';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText((usedPercent + '%'), chart.getDatasetMeta(0).data[0].x, chart.getDatasetMeta(0).data[0].y - 10);
            ctx.restore();
        }
    }

    return (
        <div className={Css.Graph_Box + ' shadow'}>
            <div className={Css.Content}>
                <div className={Css.Header}>
                    <h6>Subscription Cancellation Rate</h6>
                </div>
                <div className={Css.Content}>
                    <div className={Css.SuscriptionsCannellation}>
                        {
                            !isNaN(usedPercent) &&
                            <Doughnut data={data} options={options} plugins={[textCenter]} ></Doughnut>
                        }

                    </div>
                </div>
            </div>
            <div className={Css.Footer + ' d-none'}>
                <a href={'#'}>View Full Plan</a>
            </div>
        </div>
    )
}